<!-- Button -->
<button
  mat-icon-button
  [matTooltip]="tooltip || 'Toggle mode dark or light'"
  (click)="toggleScheme()">
  <div class="flex items-center rounded-full overflow-hidden">
    @if (scheme === 'light') {
      <mat-icon
        class="icon-size-5"
        [svgIcon]="'heroicons_solid:moon'">
      </mat-icon>
    }
    @if (scheme === 'dark') {
      <mat-icon
        class="icon-size-5"
        [svgIcon]="'heroicons_solid:sun'">
      </mat-icon>
    }
  </div>
</button>
